import { DrawerMenu } from "componentsNew/appMenus/DrawerMenu";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { Redirect, Route } from "react-router";
import { localUserService } from "utils/localStorage";

const RouteWithBars = ({
  component: Component,
  permission = 1,
  label,
  permissionKey,
  ...rest
}: any) => {
  const token = localUserService.getAccess();
  const acceptPermission = permissionKey.some((el: number) => el === permission);
  const { isLoginError } = useTypeSelectors((state) => state.auth);

  return (
    <Route
      {...rest}
      render={(props) =>
        token && acceptPermission && !isLoginError ? (
          <DrawerMenu>
            <Component {...props} />
          </DrawerMenu>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default RouteWithBars;
